const validateInputs = (currentStep: number, maxStep: number) => {
  if (maxStep <= 0) {
    throw new Error('maxStep must be greater than 0');
  }
  if (currentStep > maxStep) {
    throw new Error('currentStep must be less than or equal to maxStep');
  }
  if (currentStep < 1) {
    throw new Error('currentStep must be greater than 0');
  }
};

export const calculateProgress = (currentStep: number, maxStep: number) => {
  validateInputs(currentStep, maxStep);

  return Math.floor((currentStep / maxStep) * 100);
};
